<template>
  <table class="nav_list_table_default">
    <caption></caption>
    <thead>
    <tr>
      <th
          id=""
          v-for="(item, index) in header"
          :key="index"
          :width="item.width"
      >
        {{ $t(item.title) }}
      </th>
    </tr>
    </thead>
    <tbody>
    <LoadingOverlay
        :activeSyncProps="activeSyncProps"
        :isFullPageProps="false"
    />
    <!-- 하나도 없을 때 -->
    <tr v-if="list.length === 0"
        class="no_data"
    >
      <td :colspan="header.length">
        {{ $t('my.payment.detailsOfUsage.no_history')}}
      </td>
    </tr>
    <!-- 여러개 일 때-->
    <tr v-else
        v-for="(tr, index) in list"
        :key="index"
    >
      <td
          v-for="(td, i) in tr"
          :key="i"
      >
        <component
            :is="td.keyType"
            :item="td"
            :class="td.class"
        />
      </td>
    </tr>
    </tbody>
    <tfoot>
    <tr v-if="list.length > 0">
      <td :colspan="header.length">
        <div class="tfoot_nav">
          <img
              v-if="active !== 0"
              @click="moveToFirstPage"
              src="/images/ic/comm/ic-first-page.svg"
              class="arrow pointer"
              alt=""
          />
          <img v-else
               src="/images/ic/comm/ic-first-page-unactive.svg"
               class="arrow"
               alt=""
          />
          <img
              v-if="active !== 0"
              @click="moveToBackPage"
              src="/images/ic/comm/ic-chevron-left.svg"
              class="arrow pointer"
              alt=""
          />
          <img v-else
               src="/images/ic/comm/ic-chevron-left-unactive.svg"
               class="arrow"
               alt=""
          />
          <ul class="nav_btn">
            <li
                v-for="(item, index) in currentPageList"
                :key="index"
            >
              <a
                  @click="clickNavNum(item)"
                  :class="(item === (active + 1)) ? 'active' : ''"
              >
                {{ item }}
              </a>
            </li>
          </ul>
          <img
              v-if="(active + 1) === lastPageNum"
              src="/images/ic/comm/ic-chevron-right-unactive.svg"
              class="arrow"
              alt=""
          />
          <img
              v-else
              @click="moveToNextPage"
              src="/images/ic/comm/ic-chevron-right.svg"
              class="arrow pointer"
              alt=""
          />
          <img
              v-if="(active + 1) === lastPageNum"
              src="/images/ic/comm/ic-last-page-unactive.svg"
              class="arrow"
              alt=""
          />
          <img
              v-else
              @click="moveToLastPage"
              src="/images/ic/comm/ic-last-page.svg"
              class="arrow pointer"
              alt=""
          />
        </div>
      </td>
    </tr>
    </tfoot>
  </table>
</template>
<script>
import Types from '@/components/Table/types';
import LoadingOverlay from '@/components/loadingOverlay';

export default {
  name: 'NavListTable',
  props: {
    header: Array,
    list: Array,
    pageInfo: Object,
    activeSyncProps: Boolean
  },
  components: {
    DefaultInfoInput: Types.DefaultInfoInput,
    ButtonBox: Types.ButtonBox,
    LoadingOverlay
  },
  data() {
    return {
      active: 0, // 현재 활성화된 페이지의 인덱스
      maxPageNum: 5, // 사용자에게 보여주는 최대 페이지 갯수
      allPageNumArr: [], // 전체 페이지 넘버를 담고 있는 이중 배열
      lastPageNum: 0 // 마지막 페이지 넘버
    }
  },
  computed: {
    currentPageList() {
      // active + 1 = (사용자 눈에 보이는)페이지 넘버링, 이 속해있는 배열을 리턴한다.
      const currentPageNum = this.active + 1;
      return this.allPageNumArr.filter(item => {
        return item.includes(currentPageNum);
      })[0];
    }
  },
  methods: {
    clickNavNum(pageNum) {
      if (this.active === (pageNum - 1)) {
        return
      }
      this.active = (pageNum - 1)
      this.movePage(pageNum);
    },
    moveToBackPage() {
      if (this.active === 0) {
        // 애초에 비활성 시키셈
        return
      }
      this.active = (this.active - 1);
      const pageNum = this.active + 1;
      this.movePage(pageNum);
    },
    moveToNextPage() {
      if ((this.active + 1) === this.lastPageNum) {
        // 애초에 비활성 시키셈
        return
      }
      this.active = (this.active + 1);
      const pageNum = this.active + 1;
      this.movePage(pageNum);
    },
    moveToFirstPage() {
      if (this.active === 0) {
        // 애초에 비활성 시키셈
        return
      }
      this.active = 0;
      const pageNum = this.active + 1;
      this.movePage(pageNum);
    },
    moveToLastPage() {
      if ((this.active + 1) === this.lastPageNum) {
        // 애초에 비활성 시키셈
        return
      }
      this.active = this.lastPageNum - 1;
      const pageNum = this.lastPageNum;
      this.movePage(pageNum);
    },
    movePage(pageNum) {
      this.$emit('resetPageInfoAndList', pageNum);
      this.$emit('getDetailsOfUsageListFromServer');
    },
    makePageNavigation() {
      let i;
      let temp = [];
      const totalPage = Math.ceil(this.pageInfo.totalRow / this.pageInfo.size);

      for (i = 1; i <= totalPage; i++) {
        temp.push(i); // 사용자 눈에 보이는 페이지 넘버링
        if ((temp.length === this.maxPageNum) || i === totalPage) {
          this.allPageNumArr.push(temp);
          temp = [];
        }
      }

      const lastPageNumArr = this.allPageNumArr[this.allPageNumArr.length - 1];
      this.lastPageNum = lastPageNumArr[lastPageNumArr.length - 1];
    },
  }
}
</script>
<style lang="scss">
.nav_list_table_default {
  table-layout: unset;

  thead {
    background: var(--grey10);

    tr {
      border-bottom: 1px solid var(--grey20);

      th {
        padding: 14px 0;
        color: #999999;
      }
    }
  }

  tbody {
    position: relative;
    tr {
      border-bottom: 1px solid var(--grey20);
      vertical-align: middle;

      &.no_data {
        border: none;

        td {
          height: 220px;
          font-weight: bold;
          color: #999999;
          font-size: 15px;
          line-height: 14;
        }
      }

      td {
        vertical-align: middle;
        padding: 15px 0;
        text-align: center;
        color: #000;

        &.latest {
          font-weight: bold;
        }
      }
    }

    tr:hover {
      background: none;
    }
  }

  tfoot {

    tr {
      td {
        text-align: center;

        .tfoot_nav {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 30px 20px;

          -ms-user-select: none;
          -moz-user-select: -moz-none;
          -khtml-user-select: none;
          -webkit-user-select: none;
          user-select: none;

          .arrow {
            margin: 0 7px;
          }

          .nav_btn {
            display: flex;

            li {
              margin: 0 8px;

              a {
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                font-weight: bold;
                border-radius: 50px;
                height: 30px;
                width: 30px;
                line-height: 2.3;

                &.active {
                  color: #fff;
                  background: var(--blue70);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>